export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7129.6e7a5504.jpg";